// src/services/api-injector.ts
/**
 * Factory for creating API injection instances with set/get methods.
 * Reduces boilerplate across service files.
 */

/**
 * Create an API injector with mutable API reference.
 * @param initial - The initial API instance (e.g., tfpapi)
 * @returns Object with api getter, setApi setter, and getApi method
 */
export function createApiInjector<T>(initial: T) {
  let _api = initial;

  return {
    get api() { return _api; },
    setApi: (a: T) => { _api = a; },
    getApi: () => _api,
  };
}
